import { useTranslation } from 'react-i18next'

import EditWidgetForm from './EditWidgetForm'
import Widget from '../Widget'

export const useUSERS_COUNTER_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'USERS_COUNTER',
    name: t('widgets.usersCounter.name'),
    description: t('widgets.usersCounter.description'),
    color: 'cyan',
    icon: 'RiTimerLine',
    categories: [t('widgets.usersCounter.category')],
    previewWidth: '45%',

    initialState: {
      name: t('widgets.usersCounter.initialStateName'),
      size: { width: 25, height: 175 },
      data: {}
    },

    Presentation: Widget,
    Form: EditWidgetForm
  }
}
